import { WalletReportColumnType } from 'src/app/models/WalletReports';

/**
 * Formatação do relatório da carteira — CSV padrão Excel Brasil e letras de coluna
 * da prévia estilo planilha (M7, task 17tm466nz8b).
 *
 * `POST /wallet/reports/preview` já devolve `rows`/`csv_sample` formatados em pt-BR
 * pelo back (ver `~/trabalhos/m7-coord.md`): estas funções servem para o MOCK gerar
 * a mesma forma, e para o `report-csv-snippet` remontar o trecho a partir das linhas
 * já formatadas que a prévia devolveu — nenhuma delas reformata dinheiro ou data.
 */

/** `0→A, 25→Z, 26→AA, 27→AB` — letras de coluna de planilha, 1 ou 2 letras (chega bem antes de 702). */
export function columnLetter(index: number): string {
  let n = index + 1;
  let letters = '';

  while (n > 0) {
    const remainder = (n - 1) % 26;
    letters = String.fromCharCode(65 + remainder) + letters;
    n = Math.floor((n - 1) / 26);
  }

  return letters;
}

/** Alinhamento da coluna na prévia: dinheiro, inteiro e data à direita; o resto à esquerda. */
export function columnAlign(type: WalletReportColumnType): 'left' | 'right' {
  return type === 'money' || type === 'integer' || type === 'datetime' || type === 'date' ? 'right' : 'left';
}

/**
 * Um campo do CSV padrão Excel Brasil: aspas só quando o valor contém `;`, `"` ou quebra de
 * linha (RFC 4180), e `"` dobrado por escape. Não há separador decimal a tratar aqui — o valor
 * já chega formatado (vírgula decimal) de quem monta a linha.
 */
export function csvBrField(value: string | number | boolean | null): string {
  const text = value === null || value === undefined ? '' : String(value);

  if (/[;"\n\r]/.test(text)) {
    return `"${text.replace(/"/g, '""')}"`;
  }

  return text;
}

/**
 * CSV padrão Excel Brasil completo: BOM UTF-8, `;`, CRLF. O Excel do Brasil só abre a
 * vírgula decimal sem quebrar colunas quando o separador de campo é `;` — com `,` ele
 * cria uma coluna por casa decimal.
 */
export function buildCsvBr(headers: string[], rows: Array<Array<string | number | boolean | null>>): string {
  const lines = [headers, ...rows].map((line) => line.map(csvBrField).join(';'));
  return `﻿${lines.join('\r\n')}\r\n`;
}

/** Nome do arquivo de exportação: `smsfunnel-<tipo>-<de>-a-<ate>.<ext>`, sem acento nem espaço. */
export function reportFileName(
  typePrefix: string,
  from: string | null,
  to: string | null,
  format: 'csv_br' | 'xlsx'
): string {
  const ext = format === 'xlsx' ? 'xlsx' : 'csv';
  const period = from && to ? `${toFileDate(from)}-a-${toFileDate(to)}` : 'periodo-completo';
  return `smsfunnel-${typePrefix}-${period}.${ext}`;
}

function toFileDate(isoDate: string): string {
  const [year, month, day] = isoDate.split('-');
  return `${day}-${month}-${year}`;
}
